import _ from "lodash";
import moment from "moment";
import React, { useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { WOO_COMMERCE_ORDER_EXPAND } from "../../../../constants/modal.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useMarketCore } from "../../../../cores/market";
import { Order } from "../../../../cores/market/interface/order";
import {
  WooCommerceOrderStatus,
  WooCommerceOrderStatusColor,
  WooCommerceOrderStatusDic,
  WooCommerceStatusOptions,
} from "../../../../cores/market/woocommerce.config";
import { useMeCore } from "../../../../cores/me";
import { CL$Format } from "../../../../cores/utils";
import { PanelWembii } from "../../PanelWembii";
import { WooCommerceIcon } from "../../social/WooCommerce/WooCommerceIcon";
import { OrderModal } from "../orderModal/OrderModal";
import { OrderStatusSelector } from "../orderModal/OrderStatusSelector";
import { WooCommerceOrderStatusBadge } from "./WooCommerceOrderStatusBadge";
import { useIntl } from "react-intl";
import { Position } from "../../../../cores/globals/interfaces/globalEntity";


interface Props {
  order: Order;
}

const icon =
  "<svg preserveAspectRatio='xMidYMid' viewBox='0 0 256 153' xmlns='http://www.w3.org/2000/svg'><path d='m23.759 0h208.38c13.187 0 23.863 10.675 23.863 23.863v79.542c0 13.187-10.675 23.863-23.863 23.863h-74.727l10.257 25.118-45.109-25.118h-98.695c-13.187 0-23.863-10.675-23.863-23.863v-79.542c-.10466-13.083 10.571-23.863 23.758-23.863z' fill='#9b5b8f' /><path d='m14.578 21.75c1.4569-1.9772 3.6423-3.0179 6.5561-3.226 5.3073-.41626 8.3252 2.0813 9.0537 7.4927 3.226 21.75 6.7642 40.169 10.511 55.259l22.79-43.395c2.0813-3.9545 4.6829-6.0358 7.8049-6.2439 4.5789-.3122 7.3886 2.6016 8.5333 8.7415 2.6016 13.841 5.9317 25.6 9.8862 35.59 2.7057-26.433 7.2846-45.476 13.737-57.236 1.561-2.9138 3.8504-4.3707 6.8683-4.5789 2.3935-.20813 4.5789.52033 6.5561 2.0813 1.9772 1.561 3.0179 3.5382 3.226 5.9317.10406 1.8732-.20813 3.4341-1.0407 4.9951-4.0585 7.4927-7.3886 20.085-10.094 37.567-2.6016 16.963-3.5382 30.179-2.9138 39.649.20813 2.6016-.20813 4.8911-1.2488 6.8683-1.2488 2.2894-3.122 3.5382-5.5154 3.7463-2.7057.20813-5.5154-1.0406-8.2211-3.8504-9.678-9.8862-17.379-24.663-22.998-44.332-6.7642 13.32-11.759 23.311-14.985 29.971-6.1398 11.759-11.343 17.795-15.714 18.107-2.8098.20813-5.2033-2.1854-7.2846-7.1805-5.3073-13.633-11.031-39.961-17.171-78.985-.41626-2.7057.20813-5.0992 1.665-6.9724zm223.64 16.338c-3.7463-6.5561-9.2618-10.511-16.65-12.072-1.9772-.41626-3.8504-.62439-5.6195-.62439-9.9902 0-18.107 5.2033-24.455 15.61-5.4114 8.8455-8.1171 18.628-8.1171 29.346 0 8.013 1.665 14.881 4.9951 20.605 3.7463 6.5561 9.2618 10.511 16.65 12.072 1.9772.41626 3.8504.62439 5.6195.62439 10.094 0 18.211-5.2033 24.455-15.61 5.4114-8.9496 8.1171-18.732 8.1171-29.45.10406-8.1171-1.665-14.881-4.9951-20.501zm-13.112 28.826c-1.4569 6.8683-4.0585 11.967-7.9089 15.402-3.0179 2.7057-5.8276 3.8504-8.4293 3.3301-2.4976-.52033-4.5789-2.7057-6.1398-6.7642-1.2488-3.226-1.8732-6.452-1.8732-9.4699 0-2.6016.20813-5.2033.72846-7.5967.93659-4.2667 2.7057-8.4293 5.5154-12.384 3.4341-5.0992 7.0764-7.1805 10.823-6.452 2.4976.52033 4.5789 2.7057 6.1398 6.7642 1.2488 3.226 1.8732 6.452 1.8732 9.4699 0 2.7057-.20813 5.3073-.72846 7.7008zm-52.033-28.826c-3.7463-6.5561-9.3659-10.511-16.65-12.072-1.9772-.41626-3.8504-.62439-5.6195-.62439-9.9902 0-18.107 5.2033-24.455 15.61-5.4114 8.8455-8.1171 18.628-8.1171 29.346 0 8.013 1.665 14.881 4.9951 20.605 3.7463 6.5561 9.2618 10.511 16.65 12.072 1.9772.41626 3.8504.62439 5.6195.62439 10.094 0 18.211-5.2033 24.455-15.61 5.4114-8.9496 8.1171-18.732 8.1171-29.45 0-8.1171-1.665-14.881-4.9951-20.501zm-13.216 28.826c-1.4569 6.8683-4.0585 11.967-7.9089 15.402-3.0179 2.7057-5.8276 3.8504-8.4293 3.3301-2.4976-.52033-4.5789-2.7057-6.1398-6.7642-1.2488-3.226-1.8732-6.452-1.8732-9.4699 0-2.6016.20813-5.2033.72846-7.5967.93658-4.2667 2.7057-8.4293 5.5154-12.384 3.4341-5.0992 7.0764-7.1805 10.823-6.452 2.4976.52033 4.5789 2.7057 6.1398 6.7642 1.2488 3.226 1.8732 6.452 1.8732 9.4699.10406 2.7057-.20813 5.3073-.72846 7.7008z' fill='#fff' /></svg>";

export const WooCommerceOrderComponent = (props: Props) => {
  const intl = useIntl();
  const {
    order: {
      id,
      number,
      creationDate,
      status,
      billing: { firstName, lastName },
      currency: code,
      price,
    },
  } = props;
  const { company, socialSettings } = useMeCore();
  const { putWooCommerceOrder } = useMarketCore();
  const { turnOnModal } = useGlobalCore();

  const wooCommerceStatus = useMemo(
    () =>
      WooCommerceStatusOptions.filter(
        (status) => status.value !== WooCommerceOrderStatus.any
      ),
    []
  );

  const handleStatusChange = useCallback(
    (status: string) => {
      putWooCommerceOrder(company?.id!, id, status);
    },
    [company, id, putWooCommerceOrder]
  );

  const onClick = useCallback(() => {
    turnOnModal(
      WOO_COMMERCE_ORDER_EXPAND,
      <OrderModal
        icon={<WooCommerceIcon size="5x" active />}
        avatar={socialSettings?.wooCommerce?.avatar}
        iconString={icon}
        statusName={WooCommerceOrderStatusDic[status as WooCommerceOrderStatus]}
        statusColor={
          WooCommerceOrderStatusColor[status as WooCommerceOrderStatus]
        }
        status={
          <OrderStatusSelector
            orderStatus={wooCommerceStatus}
            status={status}
            onChange={handleStatusChange}
          />
        }
        order={props.order}
      />,
      Position.LEFT
    );
  }, [props.order, status, wooCommerceStatus, socialSettings, handleStatusChange, turnOnModal]);

  return (
    <PanelWembii className="w-100 px-4 py-3 my-2 pointer" onClick={onClick}>
      <Row>
        <Col
          xs="12"
          lg="1"
          className="text-center text-lg-start text-black-50"
        >{`#${number}`}</Col>
        <Col xs="12" lg="2">
          <div className="w-fit mx-auto">
            <WooCommerceOrderStatusBadge
              status={status as WooCommerceOrderStatus}
            />
          </div>
        </Col>
        <Col xs="12" lg="2" className="text-center">
          {moment(creationDate).format("DD/MM/YYYY")}
        </Col>
        <Col xs="12" lg="2" className="text-center">{`${CL$Format(
          +price,
          code
        )}(${code})`}</Col>
        <Col xs="12" lg="auto">
          <div className="text-center">
            <span className="text-black-50">
              {intl.formatMessage({ id: "app.onlinesales.order5" })}
            </span>
            {`${_.capitalize(lastName)} ${_.capitalize(firstName)}`}
          </div>
        </Col>
      </Row>
    </PanelWembii>
  );
};
